// extracted by mini-css-extract-plugin
export var root = "chatEmbedLayout-module--root--f0d41";